<template>
  <div class="stat-card">
    <span class="stat-card__label">Total de Serviços</span>
    <span class="stat-card__value">{{total_services || 0}}</span>
  </div>
</template>

<script>
export default {
  name:"Presentation",
  props:{
    total_services:Number
  }
}
</script>

<style scoped>
</style>